import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { boolean, nullValidation, string } from "@altostra/type-validations/lib/primitives";

import type {
  DecisioningStudioAudienceSegment,
  GetDecisioningStudioAgentsAppGroupIdDsaIdSegmentsResult,
  PutDecisioningStudioAgentsAppGroupIdDsaIdSegmentsResult,
} from "./types";

const isDecisioningStudioAudienceSegment = objectOf<DecisioningStudioAudienceSegment>({
  id: string,
  name: anyOf(string, nullValidation),
  has_agent_membership_filter: boolean,
});

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdSegmentsResult =
  objectOf<GetDecisioningStudioAgentsAppGroupIdDsaIdSegmentsResult>({
    segments_ids: (segmentsIds: unknown): segmentsIds is string[] =>
      arrayOf(string)(segmentsIds) && segmentsIds.length <= 1,
    segments: (segments: unknown): segments is DecisioningStudioAudienceSegment[] =>
      arrayOf(isDecisioningStudioAudienceSegment)(segments) && segments.length <= 1,
  });

export const isPutDecisioningStudioAgentsAppGroupIdDsaIdSegmentsResult =
  objectOf<PutDecisioningStudioAgentsAppGroupIdDsaIdSegmentsResult>({
    segments_ids: arrayOf(string),
  });
